module.exports = __webpack_public_path__ + "img/icon_law_img.a4ca4822.png";